
define('ldsh!templates/main-layout-with-sidebar', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="mdirector__main__container">\n  <div id="md__sidebar__wrapper"></div>\n  <main>\n    <div id="header"></div>\n    <section>\n      <div class="main__section__wrapper">\n        <div class="container container--margin" style="min-height: 800px;">\n          <div id="noticeContainer"></div>\n          <div id="md__reminders"></div>\n          <div id="noticeContainer"></div>\n          <div id="content"></div>\n        </div>\n      </div>\n      <div id="footer"></div>\n    </section>\n  </main>\n</div>';

}
return __p
};});

